import gsap from 'gsap'

export default class DepositView
{
    constructor(_options)
    {
        this.deposit = _options.deposit
        this.factory = _options.factory
        this.container = this.factory.createDeposit(this.deposit)
        this.container.visible = this.deposit.revealed
        this.lastOutput = -1
        this.sync()
    }

    sync()
    {
        const output = this.container.userData.output
        if(this.deposit.tree)
        {
            this.container.userData.tree.visible = this.deposit.remaining > 0
            this.container.userData.stump.visible = this.deposit.remaining === 0
        }
        else
        {
            for(const child of this.container.children)
            {
                if(child !== output)
                    child.visible = this.deposit.remaining > 0
            }
        }
        this.container.visible = this.deposit.revealed
        if(this.lastOutput === this.deposit.output)
            return
        this.lastOutput = this.deposit.output
        for(const child of [...output.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            output.remove(child)
        }
        for(let index = 0; index < this.deposit.output; index++)
        {
            const item = this.factory.createItem(this.deposit.resource, 0.95)
            item.position.set((index % 4 - 1.5) * 0.36, (Math.floor(index / 4) % 2 - 0.5) * 0.35, Math.floor(index / 8) * 0.22)
            output.add(item)
        }
    }

    reveal()
    {
        this.container.visible = true
        this.container.position.z = -1.6
        this.container.scale.setScalar(0.2)
        gsap.to(this.container.position, { z: 0, duration: 0.85, ease: 'back.out(2.2)' })
        gsap.to(this.container.scale, { x: 1, y: 1, z: 1, duration: 0.75, ease: 'back.out(2.5)' })
    }
}
